import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types';

const BASE_URL = '/v2/admin/failed-bg-check-notification';

class AdminBackgroundCheckFailedNotificationService {
  static send(
    sitterId: number,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<null>> {
    return axios.post(`${BASE_URL}/send`, { id: sitterId }, config);
  }
}

export { AdminBackgroundCheckFailedNotificationService };
